import * as React from 'react';
import classnames from 'classnames';
import { FilesList } from '@grandvisionhq/common';
import { ConfigurationSummaryDivider } from '../ConfigurationSummaryDivider/ConfigurationSummaryDivider.js';
import { SummaryTitle } from '../SummaryTitle/SummaryTitle.js';

const PrescriptionUploadSummary = ({ title , uploadReferences , hideDividers , className  })=>{
    const filteredUploadedFileNames = Object.values(uploadReferences).reduce((m, ref)=>!ref ? m : [
            ...m,
            ref.fileName
        ]
    , []);
    return (filteredUploadedFileNames === null || filteredUploadedFileNames === void 0 ? void 0 : filteredUploadedFileNames.length) ? /*#__PURE__*/ React.createElement("section", {
        className: classnames('prescription-upload-summary', className),
        "data-t": "prescription-upload-summary"
    }, /*#__PURE__*/ React.createElement(SummaryTitle, null, title), !hideDividers && /*#__PURE__*/ React.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: true,
        className: "prescription-upload-summary__divider"
    }), /*#__PURE__*/ React.createElement(FilesList, {
        items: filteredUploadedFileNames
    }), !hideDividers && /*#__PURE__*/ React.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: true,
        className: "prescription-upload-summary__divider--bottom"
    })) : null;
};

export { PrescriptionUploadSummary };
//# sourceMappingURL=PrescriptionUploadSummary.js.map
